import { defineStore, acceptHMRUpdate } from 'pinia';

const store = defineStore('ui-modals', {
  state: () => ({
    mobileview: null,
    fullscreenMode: false,
    displayLoginWindow: false,
    displayOnBoardingWelcomeModal: false,
    displayPremiumSuspended: false,
    displayPremiumExpired: false,
    displayNewVersionsWindow: false,
  }),

  actions: {
    setLoginWindow(status) {
      this.displayLoginWindow = status;
    },
    setOnBoardingWelcomeModal(status) {
      this.displayOnBoardingWelcomeModal = status;
    },
    setPremiumSuspended(status) {
      this.displayPremiumSuspended = status;
    },
    setPremiumExpired(status) {
      this.displayPremiumExpired = status;
    },
    setDisplayNewVersionsWindow(value) {
      this.displayNewVersionsWindow = value;
    },
  },
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
export default store;
